import type { FC } from "react";
import Navbar from "./Navbar";
import rupeeWatermark from "../assets/loanInMinutes/Rupee.png";
import symbolWatermark from "../assets/loanInMinutes/symbol_1.png";

const BoltIcon: FC<{ className?: string }> = ({ className }) => (
  <svg width="23" height="25" viewBox="0 0 23 25" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M5 25L10 15.625L0 14.375L15 0H17.5L12.5 9.375L22.5 10.625L7.5 25H5ZM11.9375 17.2812L16.9688 12.4688L8.5625 11.4062L10.5312 7.75L5.53125 12.5625L13.9062 13.5938L11.9375 17.2812Z" fill="white"/>
  </svg>
);

const PercentIcon: FC<{ className?: string }> = ({ className }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M4.375 8.75C3.16667 8.75 2.13542 8.32292 1.28125 7.46875C0.427083 6.61458 0 5.58333 0 4.375C0 3.16667 0.427083 2.13542 1.28125 1.28125C2.13542 0.427083 3.16667 0 4.375 0C5.58333 0 6.61458 0.427083 7.46875 1.28125C8.32292 2.13542 8.75 3.16667 8.75 4.375C8.75 5.58333 8.32292 6.61458 7.46875 7.46875C6.61458 8.32292 5.58333 8.75 4.375 8.75ZM4.375 6.25C4.89583 6.25 5.33854 6.06771 5.70312 5.70312C6.06771 5.33854 6.25 4.89583 6.25 4.375C6.25 3.85417 6.06771 3.41146 5.70312 3.04688C5.33854 2.68229 4.89583 2.5 4.375 2.5C3.85417 2.5 3.41146 2.68229 3.04688 3.04688C2.68229 3.41146 2.5 3.85417 2.5 4.375C2.5 4.89583 2.68229 5.33854 3.04688 5.70312C3.41146 6.06771 3.85417 6.25 4.375 6.25ZM15.625 20C14.4167 20 13.3854 19.5729 12.5312 18.7188C11.6771 17.8646 11.25 16.8333 11.25 15.625C11.25 14.4167 11.6771 13.3854 12.5312 12.5312C13.3854 11.6771 14.4167 11.25 15.625 11.25C16.8333 11.25 17.8646 11.6771 18.7188 12.5312C19.5729 13.3854 20 14.4167 20 15.625C20 16.8333 19.5729 17.8646 18.7188 18.7188C17.8646 19.5729 16.8333 20 15.625 20ZM15.625 17.5C16.1458 17.5 16.5885 17.3177 16.9531 16.9531C17.3177 16.5885 17.5 16.1458 17.5 15.625C17.5 15.1042 17.3177 14.6615 16.9531 14.2969C16.5885 13.9323 16.1458 13.75 15.625 13.75C15.1042 13.75 14.6615 13.9323 14.2969 14.2969C13.9323 14.6615 13.75 15.1042 13.75 15.625C13.75 16.1458 13.9323 16.5885 14.2969 16.9531C14.6615 17.3177 15.1042 17.5 15.625 17.5ZM1.75 20L0 18.25L18.25 0L20 1.75L1.75 20Z" fill="white"/>
  </svg>
);

const CalendarAltIcon: FC<{ className?: string }> = ({ className }) => (
  <svg width="27" height="28" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M2.5 25C1.8125 25 1.22396 24.7552 0.734375 24.2656C0.244792 23.776 0 23.1875 0 22.5V5C0 4.3125 0.244792 3.72396 0.734375 3.23438C1.22396 2.74479 1.8125 2.5 2.5 2.5H3.75V0H6.25V2.5H16.25V0H18.75V2.5H20C20.6875 2.5 21.276 2.74479 21.7656 3.23438C22.2552 3.72396 22.5 4.3125 22.5 5V12.5H20V10H2.5V22.5H11.25V25H2.5ZM20 27.5C18.4792 27.5 17.151 27.026 16.0156 26.0781C14.8802 25.1302 14.1667 23.9375 13.875 22.5H15.8125C16.0833 23.4167 16.599 24.1667 17.3594 24.75C18.1198 25.3333 19 25.625 20 25.625C21.2083 25.625 22.2396 25.1979 23.0938 24.3438C23.9479 23.4896 24.375 22.4583 24.375 21.25C24.375 20.0417 23.9479 19.0104 23.0938 18.1562C22.2396 17.3021 21.2083 16.875 20 16.875C19.3958 16.875 18.8333 16.9844 18.3125 17.2031C17.7917 17.4219 17.3333 17.7292 16.9375 18.125H18.75V20H13.75V15H15.625V16.7812C16.1875 16.2396 16.8438 15.8073 17.5938 15.4844C18.3438 15.1615 19.1458 15 20 15C21.7292 15 23.2031 15.6094 24.4219 16.8281C25.6406 18.0469 26.25 19.5208 26.25 21.25C26.25 22.9792 25.6406 24.4531 24.4219 25.6719C23.2031 26.8906 21.7292 27.5 20 27.5ZM2.5 7.5H20V5H2.5V7.5Z" fill="white"/>
  </svg>
);

const features = [
  {
    icon: <BoltIcon className="text-white w-5 h-5" />,
    title: "Instant Approval",
    desc: "Our AI-driven underwriting engine provides credit decisions in under 10 seconds. No more waiting days for an answer.",
    wide: true,
  },
  {
    icon: <PercentIcon className="text-white w-5 h-5" />,
    title: "Low Interest Rates",
    desc: "Competitive rates starting from 10.5% APR based on your profile.",
    wide: false,
  },
  {
    icon: <CalendarAltIcon className="text-white w-5 h-5" />,
    title: "Flexible Tenure",
    desc: "Repayment tenures ranging from 10 days to 60 days to suit your budget.",
    wide: false,
  },
];

export const WhyChooseUsSection = () => {
  return (
    <section className="py-15 bg-red-50 relative shadow-md">
      {/* Watermark clipping wrapper */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {/* Rupee watermark — top left */}
        <img
          src={rupeeWatermark}
          alt=""
          className="absolute top-5 sm:top-20 left-5 w-20 h-20 sm:w-48 sm:h-48 object-contain opacity-100 select-none"
        />
        {/* Symbol watermark — top right */}
        <img
          src={symbolWatermark}
          alt=""
          className="absolute top-0 -right-10 w-40 h-40 sm:w-64 sm:h-64 object-contain opacity-100 select-none"
        />
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="flex flex-col items-center text-center mb-14">
          <span className="text-[#CC1A1A] text-xs font-black tracking-[0.3em] uppercase mb-3">
            BEST CHOICE
          </span>
          <div className="w-8 h-0.5 bg-[#CC1A1A] mb-5" />
          <h2 className="text-4xl xl:text-5xl font-bold text-[#1a1a4e] mb-4">
            Why Choose Loan In Seconds?
          </h2>
          <p className="text-gray-400 font-light text-base">
            Experience the future of personal finance with our transparent, fast, and secure platform.
          </p>
        </div>

        {/* Feature cards — 2-col on mobile (wide card spans both), 4-col on desktop */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-5">
          {features.map((f) => (
            <div
              key={f.title}
              className={`bg-white rounded-2xl border border-[#f6bdbd] p-6 lg:p-8 flex flex-col gap-4 lg:gap-5 ${
                f.wide ? "col-span-2" : "col-span-1"
              }`}
            >
              {/* Icon square */}
              <div className="w-10 h-10 lg:w-12 lg:h-12 bg-[#CC1A1A] rounded-xl flex items-center justify-center flex-shrink-0">
                {f.icon}
              </div>
              <h3 className="text-[#CC1A1A] font-bold text-base lg:text-lg">{f.title}</h3>
              <p className="text-gray-500 text-xs lg:text-sm leading-relaxed max-w-sm">{f.desc}</p>
            </div>
          ))}
        </div>

        {/* Bottom banner */}
        <div className="bg-[#CC3333] rounded-2xl px-6 py-8 lg:px-12 lg:py-10 flex flex-row lg:flex-row items-center justify-between relative overflow-hidden">
          <div className="max-w-[75%] lg:max-w-xl">
            <h3 className="text-white font-semibold text-xl lg:text-4xl mb-3">
              No Collateral, No Assets Required
            </h3>
            <p className="text-white/80 text-sm lg:text-xl leading-relaxed">
              We trust your professional career. No need to pledge jewelry or property to get the funding you deserve.
            </p>
          </div>

          {/* Shield — absolute bottom-right on mobile, inline on desktop */}
          <div className="flex-shrink-0 w-20 h-20 lg:w-28 lg:h-28 flex items-center justify-center opacity-30">
            <svg viewBox="0 0 80 90" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
              <path
                d="M40 2L6 16v26c0 22 14.5 41.5 34 48 19.5-6.5 34-26 34-48V16L40 2z"
                stroke="white"
                strokeWidth="4"
                fill="none"
              />
              <rect x="28" y="36" width="24" height="20" rx="3" stroke="white" strokeWidth="3" fill="none" />
              <path d="M33 36v-6a7 7 0 0114 0v6" stroke="white" strokeWidth="3" strokeLinecap="round" />
              <circle cx="40" cy="46" r="3" fill="white" />
            </svg>
          </div>
        </div>

      </div>
    </section>
  );
};

const WhyChooseUs = () => {
  return (
    <div className="bg-white min-h-screen">
      <Navbar />
      <div className="pt-[73px]">
        <WhyChooseUsSection />
      </div>
    </div>
  );
};

export default WhyChooseUs;
